import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'
import IconButton from 'material-ui/IconButton'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import { Button, Grid } from 'material-ui'

const axis = {
  orient: 'left',
  tickFormat: d => (
    <text
      key={`tick-${d}`}
      style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
      y={-2}
    >
      {d}
    </text>
  ),
  tickValues: [
    0,
    2,
    4,
    6,
    8,
    10,
    12,
    14,
    16,
    18,
    20,
    22,
    24,
    26,
    28,
    30,
    35,
    40,
    45,
    50,
    55,
    60,
    65,
    70,
    75,
    80,
    85,
    90,
    95,
    100
  ],
  baseline: false,
  tickLineGenerator: ({ xy }) => (
    <path
      key={`tickLine-${xy.value}`}
      style={{ stroke: '#F0F0F0 ' }}
      d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${xy.y1}L${xy.x1},${
        xy.y1
      }Z`}
    />
  )
}

const styles = theme => ({
  tooltipContent: {
    background: 'white',
    border: 1,
    color: 'black',
    padding: 10
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  paperRoot: {
    margin: theme.spacing.unit,
    boxShadow: '0px 0px 10px #eeeeee',
    alignItems: 'center',
    padding: 10,
    height: 100
  },
  paperRootGrid: {
    padding: theme.spacing.unit
  },
  linearColorPrimary: {
    backgroundColor: 'rgba(0, 0, 0, .05)'
  },
  linearBarColorPrimary: {
    backgroundColor: 'rgba(80, 227, 194, .4)'
  },
  linearBarColorPrimaryGoal: {
    backgroundColor: 'rgba(168, 169, 255,0.5)'
  },
  linearBarColorPrimaryComplete: {
    backgroundColor: 'lightgreen'
  },
  linearBarColorPrimaryWhite: {
    backgroundColor: 'white'
  }
})

@withStyles(styles)
export default class AlchemyReadingWeeklyView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateSeleted: new Date(moment())
        .toISOString('yyyy-MM-dd')
        .substring(0, 10),
      weekNo: moment()
        .endOf('week')
        .format('l')
    }
    this.nextWeek = this.nextWeek.bind(this)
    this.prevWeek = this.prevWeek.bind(this)
    this.setToday = this.setToday.bind(this)
  }

  hoursBar = ({ data, rScale, adjustedSize, margin }) => {
    const renderedPieces = []
    const keys = Object.keys(data)

    keys.forEach(key => {
      //Only one piece of data per column though we'll render multiple graphical elements
      const column = data[key]

      //You can return an array of graphics or an array of objects with extra data (see the Waterfall chart demo)
      const markObject = (
        <g key={`piece-${key}`}>
          {column.pieceData.map(
            (piece, index) =>
              piece.data.pagesSession > 0 && (
                <g
                  key={`g-${index}-${key}`}
                  cursor={
                    moment(new Date(piece.data.date)).isAfter(moment(), 'day')
                      ? 'auto'
                      : 'pointer'
                  }
                  onClick={() => {
                    this.props.action(piece.data.date, 'other')
                  }}
                >
                  <rect
                    key={`rect-${index}-${key}`}
                    fill={
                      piece.data.log === 'grey'
                        ? 'white'
                        : 'rgba(228,228,228,.7)'
                    }
                    stroke={'white'}
                    width={`${66 / keys.length}%`}
                    height={piece.scaledValue}
                    x={column.x - 6}
                    y={piece.bottom - piece.scaledValue}
                    rx={3}
                    ry={3}
                  />
                  <text
                    key={`text-pages-${key}`}
                    x={column.x + column.width / 1.3 - adjustedSize[0] / 32 - 3}
                    y={
                      piece.bottom -
                      piece.scaledValue +
                      adjustedSize[0] / 28 +
                      3
                    }
                    fontSize={adjustedSize[0] / 24}
                    fontWeight={
                      piece.data.pagesSession === piece.data.sumDailyPages &&
                      moment(new Date(piece.data.date)).format('l') ===
                        moment().format('l')
                        ? 800
                        : 300
                    }
                    fill={'white'}
                  >
                    {piece.data.pagesSession}
                  </text>
                </g>
              )
          )}
          {parseInt(column.pieceData[0].data.sumDailyPages, 10) >=
          this.props.goal.pagesGoalLow ? (
            <text
              key={`text-${key}`}
              x={column.x + column.width / 0.8 - adjustedSize[0] / 20 - 10}
              y={
                column.pieceData[column.pieceData.length - 1].bottom -
                column.pieceData[column.pieceData.length - 1].scaledValue +
                adjustedSize[0] / 48 +
                25
              }
              fontSize={adjustedSize[0] / 16}
              fill={
                parseInt(column.pieceData[0].data.sumDailyPages, 10) >=
                this.props.goal.pagesGoalHigh
                  ? parseInt(column.pieceData[0].data.sumDailyPages, 10) >=
                    this.props.goal.pagesGoalSuperHigh
                    ? 'papayawhip'
                    : 'yellow'
                  : 'white'
              }
            >
              ★
            </text>
          ) : (
            <text key={`text-${key}`} />
          )}
          }
        </g>
      )

      renderedPieces.push(markObject)
    })
    return renderedPieces
  }

  setToday = () => {
    this.setState({
      weekNo: moment()
        .endOf('week')
        .format('l')
    })
  }

  prevWeek = () => {
    const prevWeekNo = moment(new Date(this.state.weekNo))
      .subtract(7, 'days')
      .endOf('week')
      .format('l')
    this.setState({ weekNo: prevWeekNo })
  }

  nextWeek = () => {
    const nextWeekNo = moment(new Date(this.state.weekNo))
      .add(7, 'days')
      .endOf('week')
      .format('l')
    this.setState({ weekNo: nextWeekNo })
  }

  addBlankDate = data => {
    var iDateStart = moment(new Date(this.state.weekNo)).startOf('week')
    var iDateEnd = moment(new Date(this.state.weekNo)).endOf('week')
    var daysWeek = iDateEnd.diff(iDateStart, 'days') + 1

    for (var i = 0; i < daysWeek; i++) {
      var blankDate = iDateStart
      var isSame = false

      for (var j in data) {
        if (
          moment(new Date(data[j].date)).format('l') === blankDate.format('l')
        ) {
          isSame = true
        }
      }
      if (!isSame) {
        data.splice(i, 0, {
          date: blankDate.format('l'),
          week: blankDate.week(),
          sumDailyPages: 0,
          pagesSession: 0,
          log: 'blank'
        })
        isSame = false
      }

      iDateStart = moment(blankDate).add(1, 'd')
    }

    var weekCalStart = moment(new Date(this.state.weekNo))
      .startOf('week')
      .week()
    for (i in data) {
      data[i].week = data[i].week - weekCalStart
      if (data[i].week < 0) {
        data[i].week += 52
      }
      data[i]['weekday'] = moment(new Date(data[i].date)).weekday()
    }
    var firstDate = moment(new Date(this.state.weekNo)).startOf('week')
    var addPrevDays = firstDate.weekday()
    var blankDatePrev = firstDate
    for (i = 0; i < addPrevDays; i++) {
      blankDatePrev = blankDatePrev.subtract(1, 'd')

      data.splice(0, 0, {
        date: blankDatePrev.format('l'),
        week: blankDatePrev.week() - weekCalStart,
        sumDailyPages: 0,
        pagesSession: 0,
        log: 'grey',
        weekday: blankDatePrev.weekday()
      })
    }

    return data
  }

  render() {
    if (this.props.data && this.props.data.loading) {
      return <div>Loading</div>
    }

    if (this.props.data && this.props.data.error) {
      return <div>Error</div>
    }

    const { classes } = this.props

    const dataCCHours = this.props.data

    let dataCal = []
    const keys = Object.keys(dataCCHours)
    var x = 0
    var recordsMin = []
    var recordsPage = []
    keys.forEach((key, index) => {
      const eachDay = dataCCHours[key]
      const weekNo = moment(new Date(eachDay[0])).week()

      eachDay[1].forEach((w, i) => {
        dataCal.splice(x, 0, {
          date: eachDay[0],
          week: weekNo,
          sumDailyPages: eachDay[3].toFixed(0),
          sumDailyMins: eachDay[2].toFixed(0),
          pagesSession: parseFloat(w.pages, 10).toFixed(0),
          minsSession: parseFloat(w.durationMin, 10).toFixed(0),
          log: ''
        })
        x += 1
        if (
          moment(new Date(eachDay[0]))
            .endOf('week')
            .format('l') === this.state.weekNo
        ) {
          recordsMin.push(parseFloat(eachDay[2], 10))
          recordsPage.push(parseFloat(eachDay[3], 10))
        }
      })
    })

    var weeklyPageMax = Math.max.apply(null, recordsPage) + 1
    var weeklyPageMin = 0

    dataCal = this.addBlankDate(dataCal)
    let dataCalWeek = dataCal.filter(
      w =>
        moment(new Date(w.date))
          .endOf('week')
          .format('l') === this.state.weekNo
    )

    return (
      <div>
        <div
          id="switch-months"
          style={{
            width: '70%',
            marginLeft: '15%',
            marginRight: '15%'
          }}
        >
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="baseline"
            spacing={0}
          >
            <Grid item xs={2} />
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.prevWeek()}
                disabled={this.state.isPaused}
                className="btn btn-default btn-style"
              >
                <ChevronLeftIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={4}>
              <span style={{ fontSize: 15 }}>
                {moment(new Date(this.state.weekNo))
                  .startOf('week')
                  .format('M/D')}{' '}
                -{' '}
                {moment(new Date(this.state.weekNo))
                  .endOf('week')
                  .format('M/D')}
              </span>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                onClick={() => this.nextWeek()}
                disabled={this.state.isPaused}
                className="btn btn-default btn-style"
              >
                <ChevronRightIcon style={{ fontSize: 30 }} />
              </IconButton>
            </Grid>
            <Grid item xs={2}>
              {moment(new Date(this.state.weekNo))
                .endOf('week')
                .format('l') ===
              moment()
                .endOf('week')
                .format('l') ? (
                ''
              ) : (
                <Button
                  onClick={() => this.setToday()}
                  className={classes.icon}
                  size="small"
                >
                  <span style={{ fontSize: 10 }}>Today</span>
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
        <div
          id="calendar_view_chart"
          style={{
            position: 'relative',
            textAlign: 'center',
            marginLeft:
              -this.props.width * 0.07 +
              (window.innerWidth - this.props.width / 1.28) / 2
          }}
        >
          <OrdinalFrame
            size={[this.props.width / 1.28, this.props.height / 1.28]}
            data={dataCalWeek}
            type={{
              type: this.hoursBar,
              rotate: 180
            }}
            axis={axis}
            rAccessor={d => d.pagesSession}
            oAccessor={d => moment(new Date(d.date)).format('d')}
            sortO={(a, b) => a > b}
            rExtent={[weeklyPageMin, weeklyPageMax]}
            projection="vertical"
            oPadding={this.props.width / 28}
            margin={{
              left: this.props.width / 10.5,
              top: this.props.height / 24,
              right: this.props.width / 10.5,
              bottom: this.props.height / 9.6
            }}
            oLabel={d => (
              <text
                key={`label-${d}`}
                y={15}
                fill={'#cecece'}
                textAnchor="middle"
                fontSize={14}
              >
                {d === '0'
                  ? 'S'
                  : d === '1'
                    ? 'M'
                    : d === '2'
                      ? 'T'
                      : d === '3'
                        ? 'W'
                        : d === '4' ? 'T' : d === '5' ? 'F' : 'S'}
              </text>
            )}
            annotationSettings={{
              layout: {
                type: 'marginalia',
                orient: 'right',
                textPadding: this.props.width / 21
              }
            }}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemyReadingWeeklyView.js